import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { useCurrentUser, useScrollToOnMount } from "APP_ROOT/hooks";
import Form from "MODULES/OutgoingQuotes/Detail/Send/Form";
import styles from "../styles";

export default function SendQuote({ quote, close }) {
  const currentUser = useCurrentUser();
  const scrollToRef = useScrollToOnMount();

  return (
    <div
      className="panel panel-default form-panel"
      style={styles.container}
      ref={scrollToRef}
    >
      <div className="panel-body">
        <h4 className="modal-title" style={styles.title}>
          Send Outgoing Quote
        </h4>
        <Form
          close={close}
          quote={quote}
          currentUser={currentUser}
          modal={false}
          smallForm
        />
      </div>
    </div>
  );
}

SendQuote.propTypes = {
  close: T.func.isRequired,
  quote: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/OutgoingQuotes/SendQuote.jsx